// Notification types
export type NotificationType =
  | 'task_due'
  | 'task_overdue'
  | 'reminder'
  | 'project_update'
  | 'mention'
  | 'system';

// Link types for navigation
export type NotificationLinkType = 'task' | 'project' | 'note' | 'client' | 'reminder';

// Main Notification interface
export interface Notification {
  _id: string;
  organizationId: string;
  userId: string;

  type: NotificationType;
  title: string;
  message: string;

  linkType?: NotificationLinkType;
  linkId?: string;

  isRead: boolean;
  readAt?: string;

  metadata?: Record<string, any>;

  createdAt: string;
  expiresAt?: string;
}

// Pagination
export interface NotificationPagination {
  page: number;
  limit: number;
  total: number;
  pages: number;
}

// Notifications list response
export interface NotificationsResponse {
  success: boolean;
  data: {
    notifications: Notification[];
    pagination: NotificationPagination;
  };
}

// Unread count response
export interface UnreadCountResponse {
  success: boolean;
  data: {
    count: number;
  };
}

// Single notification response
export interface NotificationResponse {
  success: boolean;
  data: {
    notification: Notification;
  };
}

// Notification type config for UI
export const NOTIFICATION_TYPE_CONFIG: Record<NotificationType, {
  icon: string;
  color: string;
  bgColor: string;
}> = {
  task_due: { icon: '⏰', color: '#ed6c02', bgColor: '#fff3e0' },
  task_overdue: { icon: '🚨', color: '#d32f2f', bgColor: '#ffebee' },
  reminder: { icon: '🔔', color: '#1976d2', bgColor: '#e3f2fd' },
  project_update: { icon: '📁', color: '#2e7d32', bgColor: '#e8f5e9' },
  mention: { icon: '👤', color: '#9c27b0', bgColor: '#f3e5f5' },
  system: { icon: 'ℹ️', color: '#757575', bgColor: '#f5f5f5' },
};
